var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"border":"","columns":_vm.columns,"loading":_vm.loading,"data":_vm.dataTable,"size":"small","height":"438"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var row = ref.row;
return [_c('Icon',{staticStyle:{"color":"#1DBF6D"},attrs:{"type":"ios-paper-outline","size":"20"},on:{"click":function($event){return _vm.linkTo(row)}}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0888c90e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/process/Apply/components/AgencyApply.vue
// module id = null
// module chunks = 